<template>
    <form id="contact_popup" @submit.prevent="addContact">
        <popup v-model="popupOpen">
            <template #content>
                <h2>השאירו פרטים</h2>
                <ul>
                    <li>
                        <label for="">שם מלא</label>
                        <input type="tel" name="name" v-model="contactFrom.name">
                    </li>
                    <li>
                        <label for="">פלאפון</label>
                        <input type="tel" name="phone" v-model="contactFrom.phone">
                    </li>
                    <li>
                        <label for="">אמייל</label>
                        <input type="email" name="email" v-model="contactFrom.email">
                    </li>
                    <li>
                        <label for="">כתובת</label>
                        <input type="text" name="address" v-model="contactFrom.address">
                    </li>
                    <li>
                        <label for="">הודעה</label>
                        <textarea id="" name="message" v-model="contactFrom.msg" cols="30" rows="10"></textarea>
                    </li>
                </ul>
            </template>
            <template #actions>
                <input type="submit" class="btn" value="שליחה">
            </template>
        </popup>
    </form>
  <div id="friends">
    <div class="centered">
        <div class="filter">
            <div class="title_type_filter">
                <h1 for="">חברים במכרז השקוף</h1>
                <div class="box_switch">
                    <div :class="{ selected: items_type === 'lawyers'}" @click="resetSearch('lawyers');" class="lawyers">עורכי דין</div>
                    <div :class="{ selected: items_type === 'entrepreneurs'}" @click="resetSearch('entrepreneurs'); " class="entrepreneurs">יזם</div>
                </div>
            </div>
            <div class="search_filter">
                <input type="text" v-model="searchInput" @input="onSearchInput" placeholder="חיפוש לפי שם היזם / חברה">
                <div class="icon search_icon"></div>
            </div>
        </div>


        <ul class="projects" ref="projectsList">
            <li v-for="item in itemsComp" :key="item.id" :data-id="item.id" class="sortable-item">
    <div class="drag-handle"></div>
                <div class="pic_name_con">
                    <div class="pic icon" :class="{radius: items_type === 'lawyers'}" v-if="items_type === 'lawyers' ? (item?.staff[0]?.pic_parsed): (item.data.company_logo)" :style="'background-image: url(' + (items_type === 'lawyers' ? item.staff[0].pic_parsed : item.data.company_logo) + ')'"></div>
                    <p class="name" v-if="items_type === 'lawyers'" v-text="item.name"></p>
                </div>
                <div class="office_data">
                    <div class="logo icon" v-if="items_type === 'lawyers'" :style="'background-image: url(' + item.data.company_logo + ')'"></div>
                    <p class="office_name" v-text="item.data.company_name"></p>
                    <div class="type_desc_con">
                        <!-- <span class="type" v-text="item.type == 'entrepreneur' ? 'יזם' : 'משרד עורכי דין'"></span> -->
                        <span class="desc" v-text="item.data.about_company"></span>
                    </div> 
                    <div class="project_details_icon_con" v-if="item.type == 'lawyer'">
                        <div class="building_icon_b icon"></div>
                        <p class="project_details"><strong  v-text="item.total_projects"></strong> מכרזים במערכת מתוכם <strong v-text="item.open_projects"></strong> בסטטוס פתוח</p>
                    </div>
                    <div class="project_details_icon_con" v-if="item.type == 'entrepreneur'">
                        <!-- <i class="far fa-building"></i> -->
                        <div class="building_icon_b icon"></div>
                        <p class="project_details">משתתף ב-<strong v-text="item.ttl_projects"></strong> מכרזים</p>
                    </div>
                </div>
                <div class="more_data">
                    <div class="address" v-if="item.data.company_address">
                        <div class="location_b_icon icon"></div>
                        <p v-text="item.data.company_address"></p>
                    </div>
                    <div class="phone" v-if="item.data.company_office_phone">
                        <div class="phone_b_icon icon"></div>
                        <p v-text="item.data.company_office_phone"></p>
                    </div>
                    <div class="ws_link" v-if="item.data.link_company_site">
                        <div class="link_b_icon icon"></div>
                        <a :href="'https://' + item.data.link_company_site" target="_blank" v-text="item.data.link_company_site"></a>
                    </div>
                    <div class="email" v-if="item.username">
                        <div class="email_b_icon icon"></div>
                        <a v-text="item.username"></a>
                    </div>
                </div>
                <div class="activity_btns_con">
                    <div class="activity" v-if="item.data.activity_areas">
                        <h5>אזורי פעילות</h5>
                        <ol class="areas">
                            <template v-for="(area, i) in item.data.activity_areas" :key="area.name">
                                <li v-if="i < 6 || item.data?.show_more_activity_areas" li class="tag" v-text="area.name"></li>
                            </template>
                           
                            <li class="continue_item" v-if="item.data.activity_areas.length > 6" @click="item.data.show_more_activity_areas = !item.data?.show_more_activity_areas">
                                <span v-if="!item.data?.show_more_activity_areas">....</span>
                                <div class="tag" v-text="item.data?.show_more_activity_areas ? ' < הצג פחות ' : 'הצג עוד >'"></div>
                            </li>
                        </ol>
                    </div>
                    <div class="btns">
                        <router-link :to="{name: 'profile', params: {id: item.id}}" class="btn">עוד על המשרד</router-link>
                        <a class="btn" @click="contactUserId
contactUserId=item.id; popupOpen=true">צור קשר</a>
                    </div>
                </div>
            </li>
        </ul>
        
        <div class="loader_con" v-if="is_loading">
            <span class="loader"></span>
        </div>

        
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs';

export default {
    data() {
        return {
            items_type: 'lawyers',
            entrepreneurs: [],
            lawyers: [],
            popupOpen: false,
            contactUserId: 0,
            contactFrom: {
                name: '',
                phone: '',
                email: '',
                address: '',
                msg: ''
            },
            searchInput: '',
            pages: {
                lawyers: {
                    num: null,
                    page: 0,
                    limit: 10,
                    items: []
                },
                entrepreneurs: {
                    num: null,
                    page: 0,
                    limit: 10,
                    items: []
                },
            },
            is_loading: false,
            sortable: null,
            ord_token: null,

        }
    },
    created() {
        this.debouncedLoadRes = this.debounce(this.loadRes, 300);
    },
    computed: {
        itemsComp() {
            return this.pages[this.items_type].items;
        }
    },
    mounted() {
        const friends_items_type = localStorage.getItem('friends_items_type')
        if (friends_items_type) {
            this.items_type = friends_items_type;
        }

        const ord_token = localStorage.getItem('ord_token')
        if (ord_token) {
            this.ord_token = ord_token;
        } else {
            this.ord_token = Math.random().toString(36).substring(7);
            localStorage.setItem('ord_token', this.ord_token);
        }

        window.addEventListener('scroll', this.handleScroll);
        this.loadRes();
        this.$nextTick(() => {
            setTimeout(() => {
                this.initSortable();
            }, 1000);
            // this.initSortable();
        });
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.sortable) {
            this.sortable.destroy();
        }
    },
    methods: {
        initSortable() {
            const el = this.$refs.projectsList
            if (!el) return;

            if (this.sortable) {
                this.sortable.destroy();
            }

            this.sortable = Sortable.create(el, {
                animation: 150,
                ghostClass: 'sortable-ghost',
                dragClass: 'sortable-drag',
                handle: '.drag-handle',
                direction: 'vertical',
                scroll: true,
                scrollSensitivity: 30,
                scrollSpeed: 10,
                onEnd: (evt) => {
                    const { oldIndex, newIndex } = evt;
                    if (oldIndex === newIndex) return;

                    // Update the items array
                    const items = this.pages[this.items_type].items;
                    const item = items.splice(oldIndex, 1)[0];
                    items.splice(newIndex, 0, item);

                    // Save the new order
                    this.saveNewOrder(items);
                }
            });
        },

        saveNewOrder(items) {
            const orderData = items.map((item, index) => ({
                id: item.id,
                order: index
            }));
            console.log(orderData);
            
            this.api({
                action: 'users/reorder',
                data: { 
                    order: orderData,
                    ord_token: this.ord_token
                }
            }, (response) => {
                if (response.data) {
                    this.toast('הסדר נשמר בהצלחה', 'success');
                } else {
                    this.toast('שגיאה בשמירת הסדר', 'error');
                }
            });
        },

        resetSearch(type) {
            this.searchInput = '';
            this.pages[type].page = 0;
            this.pages[type].items = [];
            this.chengeType(type);
            this.loadRes();
        },
        chengeType(type) {
            
            this.items_type = type;
            if (this.pages[type].items.length === 0) {
                this.loadRes();
            }
            localStorage.setItem('friends_items_type', type);
            this.$nextTick(() => {
                this.initSortable();
            });
        },
        handleScroll() {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            
            
            if (documentHeight - scrollPosition <= 1000) {
                // console.log(this.pages[this.items_type]);
                if (!this.is_loading && this.pages[this.items_type].items.length < this.pages[this.items_type].num) {
                    this.is_loading = true;
                    this.pages[this.items_type].page++;
                    this.loadRes();
                }
            }
        },
        loadRes() {
            clearTimeout(this.xhr_timer);
            this.xhr_timer = setTimeout(() => {
                this.is_loading = true;
                console.log(this.is_loading);
                
                const page_data = this.pages[this.items_type];
                
                this.api({
                    action: 'users/results',
                    data: { 
                        type: this.items_type === 'lawyers' ? 'lawyer' : 'entrepreneur',
                        q: this.searchInput,
                        page: page_data.page,
                        limit: page_data.limit,
                        ord_token: this.ord_token
                    }
                }, (data) => {
                    // If it's a new search (page 0), replace items, otherwise append
                    if (page_data.page === 0) {
                        this.pages[this.items_type].items = data.data.items;
                    } else {
                        this.pages[this.items_type].items.push(...data.data.items);
                    }
                    
                    if (data.data?.num) {
                        this.pages[this.items_type].num = data.data.num;
                    }
                    this.is_loading = false;
                    console.log(this.is_loading);
                    
                });
            }, 400);
        },
        addContact() {
            if (!this.contactUserId) return;
            this.api({ action: 'contact', data: { ...this.contactFrom, user_id: this.contactUserId }}, (data)=>{
                this.popupOpen = false;
                this.contactUserId = 0;
                this.contactFrom = {
                    phone: '',
                    email: '',
                    msg: ''
                }

                if (data.data) {
                    this.toast('פרטים נשלחו בהצלחה' , 'success');
                } else {
                    this.toast('תקלה בשליחת הפרטים נסו מאוחר יותר' , 'error');
                }

                
            })
        },
        onSearchInput() {
            this.pages[this.items_type].page = 0;  // Reset page number
            this.debouncedLoadRes();
        }
    }
}
</script>

<style lang="scss">
#contact_popup {
    #popup_content { min-height: auto; border-top: none; }
    h2 { margin: 0 auto; text-align: center; margin-bottom: 32px; }
    ul { display: flex; flex-direction: column; gap: var(--gap);}
}
#friends { 
    .centered { display: flex; flex-direction: column; gap: var(--gap_mid);}
    .filter { display: flex; justify-content: space-between; align-items: flex-end; 
        .title_type_filter { display: flex; gap: var(--gap); align-items: center;
            h1 { font-size: var(--h3); font-weight: bold; }
        }
        .search_filter { height: 40px; 
            input { padding-left: 11px; font-size: var(--h5); }
        }
    }
    .projects {  display: flex; flex-direction: column; gap: var(--gap);
        &>li { padding: 24px; display: flex; gap: var(--gap_mid); justify-content: space-between; position: relative; background: #fff; box-shadow: var(--box-shadow); border-radius: 40px;
            .pic_name_con {overflow: hidden;  flex: 1;  border: 1px solid #E7F0F3; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 30px; background: var(--gray); gap: 16px; border-radius: 32px;
                .pic { width: 100px; height: 100px; background-size: contain; background-image: url("https://blog.legaler.com/wp-content/uploads/2015/03/Pearson.jpg");
                    &.radius { border-radius: 50%; background-size: cover;}
                }
            }

            .office_data {overflow: hidden; flex: 3; display: flex; flex-direction: column; gap: var(--gap_small); justify-content: flex-start;
                .logo {  width: 150px; height: 40px;}
                .office_name { font-weight: bold; }
                .type_desc_con { display: flex; gap: var(--gap);
                    .type { position: relative; 
                        &::after { content: ''; inset-block: 1px; width: 1px; background: rgba(51, 51, 51, 0.4); position: absolute; left: calc((var(--gap) / 2) * -1); }
                    }
                    .desc {display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;}
                }
                .project_details_icon_con { margin-top: var(--gap); display: flex; gap: var(--gap_small); align-items: center;
                    .building_icon_b { width: 40px; height: 40px;}
                }
            }

            .more_data { overflow: hidden; flex: 2; display: flex; flex-direction: column; gap: var(--gap);
                &>div { display: flex; align-items: center;
                gap: var(--gap_small); }

                .icon { min-width: 30px; height: 30px;}
            }

            .activity_btns_con { overflow: hidden; flex: 3; display: flex; flex-direction: column; justify-content: space-between; gap: var(--gap);
                .activity { display: flex; flex-direction: column; gap: var(--gap_small);
                    .areas { display: flex; flex-wrap: wrap; gap: var(--gap_small);
                        .tag {    min-width: unset; background: var(--card_blue_bg); color: var(--dark_blue); border-radius: 16px; padding: 4px 12px; border: 1px solid var(--ligth_color);}
                        li {
                            &.continue_item { display: flex; gap: var(--gap_small); align-items: center; cursor: pointer;
                                span { font-weight: bold; color: var(--border_color); }
                                .tag { background: var(--dark_blue); color: #fff; padding: 4px 16px; border-radius: 16px;}
                            }
                        }
                    }
                }
                .btns { margin-top: auto; display: flex; gap: var(--gap); justify-content: flex-start;
                    .btn { flex: 1; }
                }
            }

            & {
                // Add to existing li styles
                position: relative;

                &::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    border-radius: 40px;
                    pointer-events: none;
                    transition: box-shadow 0.2s ease;
                }

                .drag-handle {
                    position: absolute;
                    right: -12px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 24px;
                    height: 48px;
                    background: var(--dark_blue);
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: grab;
                    opacity: 0;
                    transition: opacity 0.2s ease;
                    color: white;
                    z-index: 10;

                    &:hover {
                        opacity: 1;
                    }

                    &:active {
                        cursor: grabbing;
                    }

                    &::before {
                        content: '⋮⋮';
                        writing-mode: vertical-rl;
                        text-orientation: mixed;
                        font-size: 20px;
                        line-height: 1;
                    }
                }

                &:hover {
                    .drag-handle {
                        opacity: 0.6;
                    }
                }
            }

            // Sortable specific classes
            .sortable-ghost {
                opacity: 0.3;
                background: var(--pageBG);

                &::before {
                    box-shadow: inset 0 0 0 2px var(--dark_blue);
                }
            }

            .sortable-drag {
                background: white;
                box-shadow: 0 4px 16px rgba(0,0,0,0.1);
                
                .drag-handle {
                    opacity: 1;
                }
            }

            .sortable-chosen {
                .drag-handle {
                    opacity: 1;
                }
            }
        } 

    }

    .loader_con { width: 100%; display: flex; justify-content: center; margin-block: 40px;
            .loader {  width: 80px; height: 80px; display: inline-block; margin: 0 auto; position: relative; }
            .loader::after, .loader::before { content: ''; box-sizing: border-box; width: 80px; height: 80px; border-radius: 50%; border: 7px solid var(--color2); position: absolute; left: 0; top: 0; animation: animloader 2s linear infinite; }
            .loader::after { animation-delay: 1s; }

            @keyframes animloader {
                0% {
                    transform: scale(0);
                    opacity: 1;
                }
                100% {
                    transform: scale(1);
                    opacity: 0;
                }
            }
        }
}
</style>